import ReactDOM from "react-dom";
import App from "./app.js";
import "./index.css";

ReactDOM.render(<App />, document.getElementById("root"));
